import { QFormulaRule } from "../CoreApp/QFormulaRule";
import { QObjDBFieldDef } from "../CoreApp/QObjDBFieldDef";

export function AddCalcField(theID, theName, theLabel, theCode, objClass) {
  var calcFieldDef = new QObjDBFieldDef();
  calcFieldDef.InitField(theID, theName, objClass);
  calcFieldDef.SetReadOnly(true);
  calcFieldDef.SetCalcCode(theCode);
  calcFieldDef.SetFieldLabel(theLabel);
  var calcFieldFormula = new QFormulaRule();
  calcFieldFormula.InitFormulaRule(theCode);
  calcFieldDef.SetFormulaRule(calcFieldFormula);
  objClass.AddField(calcFieldDef);
  return calcFieldDef;
}
